import { CreateReactionRequest, DeleteReactionRequest, ViewReactionsRequest } from './reaction.types';

import {
  API_HOST,
  HttpDeleteOptions,
  HttpGetOptions,
  HttpPostOptions,
  getHttpDeleteOptions,
  getHttpGetOptions,
  getHttpPostOptions
} from '../../utils/api.util';

const getEndpoint = () => `${API_HOST}/reaction`;
const getspecificReactionEndpoint = (memberExternalReference: string) => `${getEndpoint()}/${memberExternalReference}`;

export const getCreateReactionRequest = (
  data: CreateReactionRequest
): [string, HttpPostOptions<CreateReactionRequest>] => [getEndpoint(), getHttpPostOptions(data)];

export const getViewReactionsRequest = (data: ViewReactionsRequest): [string, HttpGetOptions] => [
  getspecificReactionEndpoint(data.memberExternalReference),
  getHttpGetOptions()
];

export const getDeleteReactionRequest = (data: DeleteReactionRequest): [string, HttpDeleteOptions] => [
  `${getEndpoint()}/${data.reaction}/${data.memberExternalReference}/${data.postExternalReference}`,
  getHttpDeleteOptions()
];
